import { gql } from '@apollo/client';

export const GET_WORK_ORDER_TASK = gql`
  query GetWorkOrderTask($id: ID!) {
    workOrderTask(id: $id) {
      id
      version
    }
  }
`;

export const SEARCH_SHIPMENTS = gql`
  query SearchShipmentsByBooking($input: SearchShipmentInput!) {
    searchShipments(input: $input) {
      results {
        id
        version
        legs {
          commercialInvoiceDetail {
            id
            version
            status
          }
        }
      }
    }
  }
`;

export const UPDATE_SHCID = gql`
  mutation UpdateShipmentCommercialInvoiceDetail(
    $id: ID!
    $version: Int!
    $input: UpdateShipmentCommercialInvoiceDetailInput!
  ) {
    updateShipmentCommercialInvoiceDetail(
      id: $id
      version: $version
      input: $input
    ) {
      record {
        id
        version
        status
      }
    }
  }
`;
